import React, {useState, useEffect} from 'react'


import { Button } from 'reactstrap';
import { Modal, ModalDialog } from 'react-bootstrap';
import ShowMessages from '../../components/Exceptions'
import Draggable from 'react-draggable';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Swal from 'sweetalert2'


import api from '../../services/api';
import setStatistic from '../../services/apiStatistic'

import IMG_WHATSAPP from './../../assets/whatsapp-logo.png'


class DraggableModalDialog extends React.Component {
	render() {
		return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
	}
}


export default function ModalMyNumberAPIOficial({showModal, handleCloseModal, handleReload, data, editState}) {
    const [loadingBtn, setLoadingBtn]          = useState(false)
    const [loadingConnect, setLoadingConnect]  = useState(false)

    const [certificate, setCertificate]        = useState('')
    const [numberId, setNumberId]              = useState('')
    const [token, setToken]                    = useState('')
    const [accountID, setAccountId]            = useState('')
    const [numbersData, setNumbersData]        = useState([])

    const [isLogin, setIsLogin]                = useState(false)

    const [name, setName]                      = useState('')
    const [platform, setPlatform]              = useState('')
    const [number, setNumber]                  = useState('')

    const [numberTest, setNumberTest]          = useState('')

    const getNumbers = async(e,_accountID,_token) => {
        const _localAccountID = accountID || _accountID || ''
        const _localToken = token || _token || ''

        if (e)
            e.preventDefault()

        if (_localAccountID === '') {
            ShowMessages({status : 500, message : 'Informe o ID da conta da meta'})
            return
        }

        if (_localToken === '') {
            ShowMessages({status : 500, message : 'Informe o token do usuário'})
            return
        }

        setLoadingBtn(true)
        await api.post('/api/oficial/getnumbers',{accountID : _localAccountID,token : _localToken.trim().replace(/[\r\n]/g, '')})
                 .then((response) => {
                    console.log('RESPONSE',response.data)
                    setNumbersData(response.data)
                 })
                 .catch((error) => {
                    console.log('ERROR',error)
                    ShowMessages(error)
                 })
                 .finally(() => {
                    setLoadingBtn(false)
                 })
    }

    const connect = async() => {
        setLoadingConnect(true)
        await api.post('/api/oficial/auth',{number : numbersData.filter(_item => _item.id === numberId)[0]?.display_phone_number.toString().replace(/[\W_,[a-z]+/g,""),
                                            certificate,
                                            numberId,
                                            token,
                                            accountID,
                                            connectionType : 1
        })
        .then((response) => {

            console.log(response)
           if (response?.status === 200 || response.data?.status === 200) {
               setIsLogin(true)
               setName(response.data.info.verified_name)
               setPlatform(response.data.info.platform_type)
               setNumber(response.data.info.display_phone_number)
           } else {
               ShowMessages({message : response.data.message,status : 500})
           }
           handleReload()
         })
         .catch((error) => {
            console.log(error)
             ShowMessages(error)
         })
         .finally(() => {
            setLoadingConnect(false)
         })
    }

    const sendMessage = async() => {
        if (numberTest === '') {
            ShowMessages({message : "Informe o número do destinatário de mensagem.", status : 500})
            return
        }

        // if (number === '')
        //     setNumber(whatsapp.replace(/[\W_,[a-z]+/g,""))

        // await api.post('/api/v1/sendMessage',{number : (number || whatsapp).replace(/[\W_,[a-z]+/g,""),
        //                                       sender : numberTest.replace(/[\W_,[a-z]+/g,""),
        //                                       hash,
        //                                       bodyMessage : "Mensagem de teste do 55ZAP, sua API de comunicação com o WhatsApp"})
        //          .then((response) => {
        //             if (response.data.data.sent)
        //                 ShowMessages({message : "Mensagem enviada com sucesso!",status : 200})
        //             else
        //                 ShowMessages({message : "Erro ao enviar sua mensagem!",status : 500})
        //          })
        //          .catch((error) => {
        //             ShowMessages(error)
        //          })
    }

    const disconnect = async() => {
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente desconectar do WhatsApp",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          }).then(async(result) => {
            if (result.isConfirmed) {
                await api.post('/api/v1/logout',{numberId,token,connectionType : 1})
                         .then((response) => {
                            ShowMessages(response.data)
                            handleReload()
                          })
                          .catch((error) => {
                              ShowMessages(error)
                          })
            }

          })
    }

    const setData = async(clear ) => {
        setCertificate( clear ? '' : data.appkey)
        setNumberId(clear ? '' : data.environment)
        setToken(clear ? '' : data.password)
        setAccountId(clear ? '' : data.appid)
        setName(clear ? '' : data.description)
        setNumber(clear ? '' : data.number)

        if (data.appid && data.password)
            await getNumbers(null,data.appid,data.password)
    }

    useEffect(() => {
        setData(!editState)
        setStatistic('modals\\modal-mynumber-api-oficial')
    } ,[])

    return (
        <Modal size='xl' show={showModal} onHide={handleCloseModal} animation={true} backdrop="static" dialogClassName="width550"  dialogAs={DraggableModalDialog}>
            <Modal.Header closeButton>
                <Modal.Title style={{marginBottom:"0px"}}>
                    <i className="fab fa-whatsapp"></i> Conexão API Oficial
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    <div className={`box-shadow`} style={{padding:"15px"}}>
                        {isLogin ?
                            <>
                                <div className="alert alert-success" style={{padding:"15px", borderRadius:"5px"}}>
                                    <div>
                                        <span style={{fontWeight:"bold"}}>No momento você encontra-se conectado, abaixo está o seus dados de conexão.</span>
                                    </div>
                                    <div style={{display:"flex", marginTop:'30px'}}>
                                        <div>
                                            <img alt="" src={IMG_WHATSAPP} style={{width:"75px"}}/>
                                        </div>
                                        <div style={{marginLeft:"30px", display:"flex",justifyContent:"center", flexDirection:"column"}}>
                                            <div>
                                                <span style={{fontWeight:"bold"}}>Nome:</span> {name}
                                            </div>
                                            <div>
                                                <span style={{fontWeight:"bold"}}>Telefone:</span> {number}
                                            </div>
                                            <div>
                                                <span style={{fontWeight:"bold"}}>Plataforma:</span> {platform}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{height:"120px", display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    <div >
                                        <button className="btn btn-danger" onClick={e => disconnect(e)}><i className='fa fa-power-off' /> Desconectar do WhatsApp</button>
                                    </div>

                                    <div style={{borderLeft:"1px dashed #cacaca", marginLeft:"15px"}}>
                                        <div style={{marginLeft:"15px"}}>
                                            <div className="input-group">
                                                <label>Número do Destinatário</label>
                                                <PhoneInput
                                                    placeholder=""
                                                    initialValueFormat="national"
                                                    style={{display:'flex', padding:"0.295rem 0.75rem"}}
                                                    value={numberTest}
                                                    defaultCountry="BR"
                                                    className='form-control'
                                                    onChange={setNumberTest}/>
                                            </div>
                                            <button className="btn btn-success" style={{marginTop:"5px"}} onClick={e => sendMessage()}><i className='fa fa-paper-plane'/> Enviar Mensagem de Teste</button>
                                        </div>
                                    </div>

                                </div>
                            </>
                        :
                            <div>
                                <div style={{display:"flex", gap:"5px"}}>
                                    <div style={{display:"flex", gap:"5px"}}>
                                        <div>
                                            <span>ID da Conta</span>
                                            <input
                                                placeholder=""
                                                initialValueFormat="national"
                                                style={{display:'flex', padding:"0.295rem 0.75rem"}}
                                                value={accountID}
                                                className='form-control'
                                                onChange={e => setAccountId(e.target.value)}/>
                                        </div>
                                        <div style={{display:"flex",alignItems:"flex-end"}}>
                                            <button type="button" title="Obter Números Registrados" className='btn btn-success' disabled={loadingBtn} onClick={e => getNumbers(e)}>
                                                <i className={`${loadingBtn ? 'fa fa-spin fa-spinner' :'fab fa-whatsapp'}`}/>
                                            </button>
                                        </div>
                                        {numbersData && numbersData.length > 0 && (
                                            <div>
                                                <div >
                                                    <span>Números Registrados</span>
                                                    <select className='form-select' value={numberId} onChange={e => setNumberId(e.target.value)}>
                                                        <option value="">Selecine</option>
                                                        {numbersData && numbersData.map(_item => {
                                                            return <option value={_item.id}>{_item.verified_name} - {_item.display_phone_number}</option>
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <span>Token de Usuário(Access Token)</span>
                                    <textarea className='form-control' value={token} onChange={e => setToken(e.target.value)} rows={4}></textarea>
                                </div>
                                <div>
                                    <span>Certificado de Conexão</span>
                                    <textarea className='form-control' value={certificate} onChange={e => setCertificate(e.target.value)} rows={6}></textarea>
                                </div>
                                {numbersData && numbersData.length > 0 && (
                                    <div style={{ display: "flex", gap: "5px", marginTop:"15px" }}>
                                        <div style={{ display: "flex", alignItems: "flex-end" }}>
                                            <button type="button" className='btn btn-success' onClick={e => connect()} disabled={loadingConnect}>
                                                <i className={`${loadingConnect ? 'fa fa-spin fa-spinner' :'fab fa-whatsapp'}`}/> Conectar
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-ligth-gray" onClick={handleCloseModal}>
                    <em className="fa fa-door-closed"></em> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}